module.exports = __webpack_public_path__ + "static/media/avatar_35.0bd3905c.svg";